module.exports = __webpack_public_path__ + "img/result_success.926a64a1.png";